import React, { createContext, useContext } from "react";
const ReactionsContext = createContext({
    reactions: false,
    replies: false,
    imagePreview: false,
    storageUrl: undefined,
});
export function FeatureFlagsProvider({ reactions, replies, storageUrl, imagePreview, children, }) {
    return (React.createElement(ReactionsContext.Provider, { value: { reactions, replies, storageUrl, imagePreview } }, children));
}
export default function useFeatureFlags() {
    const showReactions = useContext(ReactionsContext);
    if (!showReactions)
        return { reactions: false, replies: false, imagePreview: false };
    return showReactions;
}
//# sourceMappingURL=useFeatureFlags.js.map